export default 
{
    App:{
        Title:"ROOM SERVICE",
        BackHome:"Retour à la page d'accueil",
        Logout:"Se déconnecter",        
        ChangePassword:"Modifier mon mot de passe",    
        CreateUser:"Creer fiche client",
        CreateUserAccess:"Creer un compte client",        
        Reception:"Reception",
        ListCustomer:"Liste client en chambre",
        RoomService:"Room service",
        OrderManagement:"Gestion des commandes",
        OrderHistory:"Historique des commandes",
        AddOrder:"Créer une commande",
        Administration:"Administration",
        UserAccount:"Comptes utilisateur",
        MailSkin:"Skin de mail",
        MailTemplate:"Template de mail",
        QrCode:"QrCode",
        AlertAddCart:"Attention"
    },
    Reception:{
        FirstName:"Prénom",
        LastName:"Nom",
        MailAdress:"Adresse mail",
        VillaSuiteNb:"N° Suite / Villa",
        TelNb:"N° Tel mobile",
        DateOfStay:"Date séjour",
        SendRequest:"Envoyer demande",
        SendConfirmation:"Valider et envoyer confirmation",
        SendLoginEmail:"Envoyer mail de connexion",
        AutoConnect:"S'auto connecter",
        CustomerAccess:"Accès client terre blanche hotel",    
        Valid:"Validé",
        WaitingValidation:"En attente de validation",
        GustInRoom:"Clients en chambre",
        CreateFile:"Créer une fiche client",
        AlertDelete:"Voulez vous vraiment supprimer le sejour",
        CustomerToCome:"Séjour à venir",
        CheckIn:"Entrée | Entrées",
        CheckOut:"Sortie | Sorties",
        AlertCreate:"Votre demande a bien été prise en compte. Vous recevrez une validation de votre compte par e-mail",
        AlertCreateTitle:"Demande envoyée"
    },
    User:{
        FirstName:"Prénom",
        LastName:"Nom",
        MailAdress:"Adresse mail",
        SendLoginEmail:"Envoyer mail de connexion",
        AlertDelete:"Confirmez vous la suppression de l'utilisateur '{name}'"
    },
    Cart:{                
        SeeCart:"Voir le panier",
        YourCart:"VOTRE PANIER",
        Continue:"Continuer",
        Comments:"Commentaire, allergies, divers",
        UnitPrice:"Prix unitaire",
        Quantity:"Quantité",
        NbGuest:"Nombre de couverts*",
        NbGuestInfos:"Préciser le nombre de couverts souhaités (obligatoire)",
        TimeDelivery:"Heure de livraison souhaitée*",
        TotalTTC: "Total TTC",
        PartTVA: "Dont TVA",
        PriceService:"Prix net, service inclus",
        Add:"Ajouter",
        Remove:"Retirer",
        ClientName:"Nom client",
        FinalizeOrder:"Afin de finaliser la commande",
        FinalizeOperator:"un opérateur va vous recontacter.",
        FinalizeChoice:"Merci de choisir comment être recontacté.",
        InOrderToValidate:"Afin de valider votre commande identifiez vous ou créez un accès",
        InOrderToCreate:"Afin de créer votre commande identifiez vous ou créez un accès",
        InOrderToValidateEnterStay:"Afin de valider votre commande renseignez vos date de séjour",
        InOrderToCreateEnterStay:"Afin de créer votre commande renseignez vos date de séjour",
        AlertRemoveItem:"Souhaitez-vous retirer complètement ce produit de votre panier ?",
        Clear:"Vider le panier",
        AlertClear:"Souhaitez-vous complètement vider votre panier?",
        AlertDelevery:"Afin de valider votre commande vous devez choisir un crenaux de livraison valide",
        AlertDeleveryTitle:"Choisissez un crenaux de livraison",
        AlertOrderSavedTitle:"Merci !",
        AlertOrderSaved:"Votre commande à bien été enregistrée",
        AlertProductMix:"Merci de vider votre panier au préalable.<br/>La sélection de plats mixtes <br/>( petit déjeuner / Diner, Déjeuner) <br/>n'est pas possible.",
        AlertProductMixTitle:"Attention"
    },
    Dish:{
        HideAllergens:"Masquer les allergènes",
        ShowAllergens:"Afficher les allergènes",
        Allergens:"Allergènes",        
        SelectOptions:"sélectionnez la composition de vos options",
        IncludedTitle:"Inclus dans votre",
        Included:"inclus",
        CravingMore:"Envie de plus",
        SupplementTitle:"Supplement à la carte",
        YourSupplementTitle:"Votre supplement à la carte | Vos supplements à la carte",
        SelectedCooking:"Cuisson sélectionnée",
        ChooseCooking:"Choisir la cuisson",
        AlertEggCookingTitle:"Choix de la cuisson de vos oeufs",
        AlertEggCooking:"Vous devez choisir le mode de prépartion de vos oeufs",
        ChooseCookingTitle:"CHOISISSEZ VOTRE CUISSON",        
        SelectedFlavor:"Variante sélectionnée",
        ChooseFlavor:"Choisir la variante",
        ChooseFlavorTitle:"CHOISISSEZ",               
        SelectedSideDish:"Accompagnement sélectionné | Accompagnements sélectionnés",
        ChoiceSideDish:"accompagnement inclus | accompagnements inclus",            
        BeyondSideDish:"au-delà, accompagnement supplémentaire de",
        SideDish:"Accompagnement en supplement à",
        AlertSideDishesTitle: "Vous semblez avoir oublié quelque chose !",
        AlertSideDishes:"Vous n’avez pas sélectionné tous les accompagnements inclus. Il vous reste {n} choix. Souhaitez-vous tout de même poursuivre?",
        SnackAddCart:"{plat} a bien été ajouté au panier pour un montant total de {prix} | {n} {plat} ont bien été ajoutés au panier pour un montant total de {prix}",   
        SnackAddBreakfastSupplement:"{plat} a bien été ajouté en supplément pour un montant total de {prix} | {n} {plat} ont bien été ajoutés en supplément pour un montant total de {prix}",
        Edit:"Modifier la sélection",
        MissingOptionItemAlert:"Une sélection de '{plat}' est manquante | {n} sélections de '{plat}' sont manquantes",
        MissingOptionAlertTitle: "Vous semblez avoir oublié quelque chose !",
        MissingOptionAlert:"<ul class='mb-2'><li>{message}</li></ul> voulez vous tout de même valider votre menu '<strong>{plat}</strong>'",
        BtnCookingTime:"Temps de cuisson*",
        CookingTime:"Temps de cuisson : {time}",
        ChefChoice:"Choix du chef",        
        AlertTimeCooking:"Il semble que vous n'ayez sélectionné aucun temps de cuisson<br/><br/><strong>Laisser le Chef choisir à votre place ?</strong>",
        ModifyConfig:"Modifier mes choix",
        RecapBreakfast:"Récapitulatif menu petit déjeuner",
        DesiredQty:"Quantité souhaitée",
        RecapEgg:"Récapitulatif de la configuration de vos oeufs"
    },
    ChangePassword:{
        Title:"Change my password",
        OldPassword:"Old Password",
        NewPassword:"New Password",
        Modify:"Send change",
        ChangePasswordProgress:"Change password in progress",
        ChangePasswordSuccess:"Change password success",
        ChangePasswordError:"Change password error"
    },        
    Global:{
        Yes:"oui",
        No:"non",
        Warning:"Attention",
        Ok:"Ok",
        Validate:"Valider",
        Delete:"Supprimer",
        Cancel:"Annuler",
        Save:"Sauvegarder",
        Close:"Fermer", 
        Choose:"Choisir",
        Language:"Langue",
        Edit:"Modifier",
        With:"Avec",
        Without:"Sans",
        WeAre:"Nous sommes le",
        Welcome:"Bienvenue",
        DiscoverCards:"Découvrir l'ensemble de nos cartes",
        Between:"entre",
        And:"et",
        Full:"Complet",
        Loaded:"Chargé",
        UpdateDeliverySlots:"Mise à jour des crenaux",
        Today:"Aujourd'hui",
        Tomorrow:"Demain",
        Yesterday:"Hier",
        FormatPeriode:"du {start} au {end}",
        download:"Télécharger",
        Days:"j",
        Back:"Retour",
        ConfirmDelete:"Confirmer la suppression",
        Reset:"Reinitialiser"
    }, 
    Icon:{
        omelette:"omelette",
        'omelette-blanc':"omelette<br/><span class='subLine3'>(blancs d'oeuf uniquement)</span>",
        brouilles:"brouillés",
        'brouilles-blanc':"brouillés<br/><span class='subLine3'>(blancs d'oeuf uniquement)</span>",
        auPlat:"au plat",
        poches:"pochés",
        coque:"à la coque",
        dur:"dur"
    },
    Menu: {
        Cart:"Carte room service",
        Print:"Imprimer carte room service"
    },
    LangSwitcher:{
        Tooltip:"Langue"
    },    
    Login: {
        Login: "Identification",
        Email: "Email",
        Password: "Mot de passe",
        LoginAction: "S'identifier",
        SendRequest:"Envoyer la demande",
        CancelRequest:"Retour à l'identification",
        AuthenticationProgress: "Identification en cours",
        AuthenticationSuccess: "Identification réussie",
        AuthenticationError: "Erreur d'identification",
        PassForgottenSuccess:"Demande envoyée avec succès",
        PassForgottenProgress:"Demande en cours",
        PassForgottenError:"Erreur : Le compte et le mail ne correspondent pas",
        ForgotPassword:"Mot de passe oublié",
        InfosLogin:"Vous pouvez vous identifier automatiquement avec le lien que vous avez reçu par mail, ou demander une modication de mot de passe avec le lien ci-dessous",
        CreateAccess:"Creer un accès",
        InfosAccount:"Votre compte n'est pas encore activé",
        EnterStayDate:"Renseigner vos dates de séjour",
        StayDate:"vos dates de séjour"
    },
    Commande:{
        BreakFastToComme:"Petit déjeuner à venir",
        DinerToComme:"Dejeuner / diner à venir",
        Passed:"Commande passée",
        AddDish:"Ajouter des plats à la commande",
        Date:"Date et heure de la commande",
        SendMail:"Renvoyer la confirmation par e-mail",
        Language:"Langue",
        AlertDelete:"Voulez vous vraiment supprimer la commande",        
        Validate:"Valider et envoyer confirmation",
    }
}
